import { UserSearchDto } from '../../../shared/modules/users/dtos/user-search.dto';
import { AgentSearchDto } from '../../agents/dtos/agent-search.dto';
import { CustomerSearchDto } from '../../customers/dtos/customer-search.dto';
import { LocationSearchDto } from '../../locations/dtos/location-search.dto';
import { RentalAgreementSearchDto } from '../../rental-agreements/dtos/rental-agreement-search.dto';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { TagSearchDto } from '../../tags/dtos/tag-search.dto';
import { VehicleSearchDto } from '../../vehicles/dtos/vehicle-search.dto';

/**
 * Search Results DTO
 */
export class SearchResultsDto {
	users!: UserSearchDto[];
	locations!: LocationSearchDto[];
	customers!: CustomerSearchDto[];
	suppliers!: SupplierSearchDto[];
	agents!: AgentSearchDto[];
	vehicles!: VehicleSearchDto[];
	rentalAgreements!: RentalAgreementSearchDto[];
	tags!: TagSearchDto[];
}
